import React, { useState, useEffect, useRef, useCallback, useLayoutEffect, useMemo } from 'react';
import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material';
import { VariableSizeList } from 'react-window';
import { useNavigate } from 'react-router-dom';
import {
  useLazyGetAllNewsQuery,
  useDeleteNewsMutation,
  useGetNewsByIdQuery,
  useLazyGetNewsByIdQuery,
} from '../gnnApiSlice';
import { selectCurrentUser, selectNotificationNewsId, setGnnStatus, setNotificationNewsId } from '../../Auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import LikesModal from './LikesModal';
import PostNewsDialog from './PostNewsDialog';
import NewsRow from './NewsRow';
import useSocket from '../../../hooks/sockets/useSocket';
import { useTheme } from '@emotion/react';
import { useExpanded } from '../contexts/ExpandedContext';
import InfiniteLoader from 'react-window-infinite-loader';
import { empty } from '../../Gift/assets/index';
import { Newspaper } from '@mui/icons-material';
import { variants } from '../../../variants/variants';
import NewsComments from './NewsComments';
import CustomDialogBox from '../../../common/CustomDialogBox';
import NewsDetailsNavbar from './NewsDetailsNavbar';
import { resetPostNews } from '../gnnSlice';
import RowVirtualizerDynamic from './tanstack/RowVirtualizerDynamic';
import { useVirtualizer } from '@tanstack/react-virtual';

const NewsList = ({
  setNewsPosted,
  newsPosted,
  selectedCategory,
  searchTerm,
  selectedCountry = '',
  selectedRegions = '',
  children,
}) => {
  const { newsData, setNewsData } = useExpanded();
  const user = useSelector(selectCurrentUser);
  const navigate = useNavigate();
  const [deleteNews] = useDeleteNewsMutation();
  const [likesModalOpen, setLikesModalOpen] = useState(false);
  const [currentLikes, setCurrentLikes] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false); // State to control dialog visibility
  const [selectedNewsId, setSelectedNewsId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isNextPageLoading, setIsNextPageLoading] = useState(false);
  const { socket } = useSocket();
  const dispatch = useDispatch();
  const empCode = user?.empCode;
  const [itemSizes, setItemSizes] = useState({});
  const [getNewsById, { isFetching }] = useLazyGetNewsByIdQuery();
  const theme = useTheme();
  // const { expandedItems, listRef } = useExpanded();
  const [getAllNews, { data }] = useLazyGetAllNewsQuery();
  const [itemCountTotal, setItemCountTotal] = useState(0);
  const parentRef = useRef(null);
  const virtualizer = useVirtualizer({
    count: newsData?.length === 1 ? 2 : newsData?.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 200,
    overscan: 5,
  });
  const notificationNewsId = useSelector(selectNotificationNewsId);

  const handleRefresh = () => {
    setPage(1);
    setNewsData(['buffer']);
    setHasMore(true);
    setItemCountTotal(0);
  };

  useEffect(() => {
    handleRefresh();
  }, [selectedCategory]);

  useEffect(() => {
    // Only reset the page and clear data when filters change
    // This allows the cache to be used when navigating back to the page
    if (newsData.length > 1 || loading) {
      console.log('Resetting news data due to filter change');
      handleRefresh();
    }
  }, [selectedCategory, searchTerm, newsPosted]);

  // useEffect(()=>{
  //     function handleNewsId(event) {
  //       console.log('notification', event?.data);
  //             const message = JSON.parse(event?.data);
  //             // console.log("type of message", typeof message.data?.newsId);
  //             console.log("type of message", message);
  //             if (message?.type === "NotificationData") {
  //               console.log('i am here in notification message',typeof message?.data?.newsId,message?.data?.newsId)
  //               // setNewsId(message.data?.newsId);
  //               handleCardClick(message?.data?.newsId)
  //               // dispatch(setNotificationNewsId(message.data?.newsId))
  //             }
  //           }
  //       document.addEventListener("message",handleNewsId);
  //       window['ReactNativeWebView'] &&
  //       window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'newsId', value: "received" }));
  //       // console.log("newsId", newsId);
  //       // dispatch(setNotificationNewsId(newsId))
  //       return () => {
  //         document.removeEventListener("message", handleNewsId);
  //       };
  //     },[])

  // console.log("notificationNewsId", notificationNewsId);
  // useEffect(() => {
  //   if (notificationNewsId) {
  //     handleCardClick(notificationNewsId);
  //     // dispatch(setNotificationNewsId(null));
  //   }
  // },[notificationNewsId]);

  // useEffect(() => {
  //   if (!loading && newsData.length === 1 && hasMore) {
  //     loadNextPage(); // Load the first page of data when component mounts or when newsposted changes
  //   }
  // }, [newsPosted, loading, newsData.length, hasMore]);

  useEffect(() => {
    const handleNewCount = (message) => {
      setNewsData((prevNews) =>
        prevNews?.map((news) =>
          news?._id === message._id
            ? {
                ...news,
                likes: message.likes,
                comments: message.comments,
                viewCount: message.viewCount,
                top5News: message.top5News,
              }
            : news
        )
      );
    };

    socket.on('new-count', handleNewCount);

    return () => {
      socket.off('new-count', handleNewCount);
    };
  }, [socket]);

  useLayoutEffect(() => {
    dispatch(setGnnStatus(false));
  }, [dispatch]);
  const handleLikesClick = async (event, likes, newsId) => {
    event.stopPropagation();
    setLikesModalOpen(true);
    const newData1 = await getNewsById(newsId).unwrap();

    const newData = newData1[0];
    setNewsData((prevNews) =>
      prevNews?.map((news) =>
        news?._id === newData._id
          ? {
              ...news,
              likes: newData.likes,
              comments: newData.comments,
              viewCount: newData.viewCount,
              top5News: newData.top5News,
            }
          : news
      )
    );
    setCurrentLikes(newData.likes);
  };

  const handleCardClick = (id) => {
    navigate(`/home/announcement/gnnDetails/${id}`);
    // setSelectedNewsId(id);
    // setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    alert('back clicked');
    console.log('back clicked');
    window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'backClicked', data: true }));
    navigate(`/home/announcement/gnn`);
    // setDialogOpen(false);
  };
  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedNews([]);
    setIsEdit(false);
    dispatch(resetPostNews());
  };

  const handleEditClick = (event, news) => {
    event.stopPropagation();
    setSelectedNews(news);
    setEditDialogOpen(true);
    setIsEdit(true);
  };

  const handleDeleteClick = async (event, id) => {
    event.stopPropagation();
    try {
      await deleteNews(id).unwrap();
      const deletedIndex = newsData.findIndex((news) => news._id === id);

      setNewsData((prevData) => prevData.filter((news) => news._id !== id));
    } catch (error) {
      console.error('Error deleting news:', error);
    }
  };

  const loadNextPage = useCallback(async () => {
    setLoading(true);

    if (isNextPageLoading || !hasMore) return;
    setIsNextPageLoading(true);
    try {
      const response = await getAllNews({
        category: selectedCategory,
        page,
        userEmpCode: empCode,
        searchTerm: searchTerm || '',
        pageSize: 4,
      }).unwrap();
      console.log('news data', response.data);
      // setNewsData((prevData) => [...prevData, ...response.data]);
      // setItemCountTotal((prev) => prev + response.data.length);
      // setItemCountTotal(response.totalCount);

      if (response.data.length > 0) {
        setNewsData((prevData) => {
          const updatedData = [...prevData];
          for (const data of response.data) {
            if (!prevData.some((item) => item._id === data._id)) {
              updatedData.push(data);
            }
          }
          return updatedData;
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false); // No more data to load
      }
      // if (response.data.length < 4) {
      //   setHasMore(false);
      // } else {
      //   setPage((prevPage) => prevPage + 1);
      // }
    } catch (error) {
      console.error('Error fetching news:', error);
    } finally {
      setIsNextPageLoading(false);
      setLoading(false);
    }
  }, [page, selectedCategory, newsPosted, empCode, searchTerm, isNextPageLoading, hasMore, currentLikes]);

  useEffect(() => {
    const [lastItem] = [...virtualizer.getVirtualItems()].reverse();
    if (!lastItem) {
      return;
    }

    if (lastItem.index >= newsData?.length - 1 && hasMore && !isNextPageLoading) {
      loadNextPage(); // Load more data as we scroll to the bottom
    }
  }, [
    newsData,
    hasMore,
    isNextPageLoading,
    virtualizer
      .getVirtualItems()
      .map((item) => item.index)
      .join(','),
    loadNextPage,
    selectedCategory,
  ]);

  useEffect(() => {
    // Handle messages from React Native
    const handleMessage = (event) => {
      if (event.data === 'closeDialog' && (dialogOpen || editDialogOpen)) {
        handleCloseDialog();
        handleEditDialogClose();
      } else {
        try {
          let message = event.data?.split('-');
          if (message[0] === 'news') {
            handleCardClick(message[1]);
            window['ReactNativeWebView'] && window['ReactNativeWebView']?.postMessage(JSON.stringify(message));
          }
        } catch (err) {}
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dialogOpen, editDialogOpen, handleEditDialogClose, handleCloseDialog]);

  const handleMediaLoad = (index) => {
    virtualizer.measureElement(virtualizer.getVirtualItems()[index]);
  };

  return (
    <>
      <div style={{ width: '100%', height: 'auto', background: '#fff' }}>
        <RowVirtualizerDynamic
          rows={newsData}
          children={children}
          handleCardClick={handleCardClick}
          handleDeleteClick={handleDeleteClick}
          handleLikesClick={handleLikesClick}
          handleEditClick={handleEditClick}
          virtualizer={virtualizer}
          parentRef={parentRef}
          showLoader={loading && page === 1}
          showDefault={newsData?.length === 1 && !loading}
          showLoading={isNextPageLoading && hasMore}
          showEnd={!hasMore}
          handleMediaLoad={handleMediaLoad} // Prop to handle media loading
          handleRefresh={handleRefresh}
        />
      </div>
      <LikesModal
        open={likesModalOpen}
        onClose={() => {
          setLikesModalOpen(false);
          setCurrentLikes([]);
        }}
        likes={currentLikes}
        loading={isFetching}
      />
      <PostNewsDialog
        open={editDialogOpen}
        onClose={handleEditDialogClose}
        newsData={selectedNews}
        isEdit={isEdit}
        setNewsPosted={setNewsPosted}
      />
      <CustomDialogBox
        open={dialogOpen}
        handleClose={handleCloseDialog}
        // title="News Details"
        content={
          <>
            <Grid
              item
              xs={12}
              lg={9.5}
              container
              sx={{
                flex: 1,
                p: 1,
                pl: 0,
                display: 'grid',
                gridTemplateRows: '70px 1fr',
                height: '100%',
                width: '100%',
                [theme.breakpoints.down('lg')]: {
                  display: 'grid',
                  p: 0,
                },
              }}
            >
              <NewsDetailsNavbar handleNavigate={handleCloseDialog} />

              <NewsComments id={selectedNewsId} />
            </Grid>
          </>
        } // Pass the selected news ID to NewsComments
        width="100%"
        height="100%"
        fullScreen={false}
        margin={0}
        padding={0.4}
        shouldAnimate={false}
      />
    </>
  );
};

export default NewsList;
